let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("h2MrD"), load("bYT2S"), load("d9GTB")]).then(() => parcelRequire('hcjUE'));